/**
 * APEE — About Page · v2 · Progressive Enhancement
 *
 * Without this file:
 * - All content visible (opacity: 1 by default)
 * - Video plays natively with controls
 * - Carousel scrolls via CSS scroll-snap
 *
 * With this file:
 * - Subtle scroll-reveal on sections
 * - Gallery dot indicator on mobile
 * - Custom video play button (poster → play)
 */

(function () {
  'use strict';

  var root = document.getElementById('apee-about');
  if (!root) return;

  /* ---- 1. Scroll reveal ---- */
  function initReveal() {
    var els = root.querySelectorAll('[data-apee-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;

    root.classList.add('apee-js');

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          entries[i].target.classList.add('apee-visible');
          observer.unobserve(entries[i].target);
        }
      }
    }, { threshold: 0.12, rootMargin: '0px 0px -32px 0px' });

    for (var i = 0; i < els.length; i++) {
      observer.observe(els[i]);
    }
  }

  /* ---- 2. Gallery dots ---- */
  function initGalleryDots() {
    var track = root.querySelector('.apee-gallery-track');
    var dots = root.querySelectorAll('.apee-gallery-dot');
    if (!track || dots.length < 2) return;

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return;
      var idx = Math.round((track.scrollLeft / max) * (dots.length - 1));
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('active', i === idx);
      }
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    update();
  }

  /* ---- 3. Video play button ---- */
  function initVideo() {
    var frame = root.querySelector('.apee-video-frame');
    if (!frame) return;

    var btn = frame.querySelector('.apee-video-play');
    var video = frame.querySelector('video');
    if (!btn || !video) return;

    btn.addEventListener('click', function () {
      frame.setAttribute('data-playing', '');
      video.play();
    });

    video.addEventListener('pause', function () {
      if (!video.ended) {
        frame.removeAttribute('data-playing');
      }
    });

    video.addEventListener('ended', function () {
      frame.removeAttribute('data-playing');
    });
  }

  /* ---- Init ---- */
  function init() {
    initReveal();
    initGalleryDots();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();